<script lang="ts">
	import Pin from 'components/search/Pin.svelte'
	import Input from '@isoftdata/svelte-input'

	interface Props {
		to?: string
		from?: string
		label?: string
		disabled?: boolean
		isPinned?: boolean
		id?: string
		change?: (value: { from: string; to: string }) => void
	}

	let {
		to = $bindable(''),
		from = $bindable(''),
		label = '',
		disabled = false,
		isPinned = false,
		id = '',
		change,
	}: Props = $props()
</script>

<label
	for={id}
	class="col-form-label pb-0"
	>{label} <Pin {isPinned} />
</label>
<div class="form-row">
	<div class="col-12 col-md-6">
		<Input
			{id}
			label="From"
			{disabled}
			bind:value={from}
			onchange={() => {
				if (from && !to) {
					to = from
				}
				change?.({ from, to })
			}}
		/>
	</div>

	<div class="col-12 col-md-6">
		<Input
			label="To"
			{disabled}
			bind:value={to}
			onchange={() => change?.({ from, to })}
		/>
	</div>
</div>
